const baseUrl = '/api/v1/order';
export const proceedOrderUrl = `${baseUrl}/proceed-sendoso`;
export const getTenantOrdersUrl = `${baseUrl}/tenant-sendoso`;
export const proceedDutyOrderUrl = '';
export const proceedAdminUrl = '';